import { NhanVienResponse } from '@app/models/nhanvien/NhanVien';
import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDSNhanVienCoQuyenBCHCongDoan } from '../../services/quyen';

export const convertDataSelectBox = (data: any) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: NhanVienResponse) => {
            return {
                value: _item.id,
                label: _item.hoTen
            }
        });
    }
    return rs;
}
const BanChapHanhCongDoanSel = ({ value, disabled, allowClear, onChange }: { value?: number | number[], disabled?: boolean, allowClear?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = convertDataSelectBox(await layDSNhanVienCoQuyenBCHCongDoan());
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn nhân sự--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            disabled={disabled}
            allowClear = {allowClear}
            onChange={(e) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
        />
    );
};

export default BanChapHanhCongDoanSel;
